import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import ScrollToTop from "../pages/ScrollToTop";
import Home from "../pages/Home";
import About from "../Components/About";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import DeveloperCard from "../Components/DeveloperCard";
import Products from "../Components/products/Products";
import ProcessSection from "../Components/ProcessSection";
import ContactExport from "../Components/ContactUS";
import GstCertification from "../Components/gst/GstCertification";

function Layout() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <Navbar />

      {/* ✅ TOASTER (GLOBAL) */}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
        toastStyle={{
          alignItems: "center",
        }}
        bodyStyle={{
          alignItems: "center",
          display: "flex",
        }}
        closeButton={true}
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products/:category" element={<Products />} />
        <Route path="/products" element={<Products />} />
        <Route path="/process" element={<ProcessSection />} />
        <Route path="/developer" element={<DeveloperCard />} />
        <Route path="/contact" element={<ContactExport />} />
        <Route path="/certifications" element={<GstCertification />} />

      </Routes>

      {/* Hide Footer on /developer */}
      {location.pathname !== "/developer" && <Footer />}
      {/* ✅ TOAST FIX CSS */}
      <style>{`
        /* TOAST CONTAINER */
        .Toastify__toast {
          border-radius: 14px;
          padding: 12px 14px;
          min-height: 60px;
          font-family: Poppins, sans-serif;
        }

        /* TOAST BODY */
        .Toastify__toast-body {
          display: flex;
          align-items: center;
          gap: 10px;
          margin: 0;
          padding: 0;
        }

        /* FIX CLOSE BUTTON */
        .Toastify__close-button {
          width: auto !important;
          height: auto !important;
          background: transparent !important;
          border: none !important;

          display: flex !important;
          align-items: center !important;
          justify-content: center !important;

          padding: 0 !important;
          margin-left: 10px !important;

          position: absolute !important;
          top: 12px !important;
          right: 12px !important;
        }

        /* REMOVE STRETCH */
        .Toastify__close-button > svg {
          width: 14px !important;
          height: 14px !important;
        }
`}</style>
    </>
  );
}

function AppRoutes() {
  return (
    <Router>
      {/* <screenTop/> */}
      <Layout />
    </Router>
  );
}

export default AppRoutes;
